import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "yourTimezone", "timezoneSelect", "start", "finish", "allDay", "timeFields" ]

  connect() {
    const detectedTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // For new blocks: set "Your timezone" option value to the detected timezone.
    // For existing blocks: the server pre-selects the stored timezone and pre-fills
    // the option value, so only update "Your timezone" if it has no value yet.
    if (this.yourTimezoneTarget.value === "") {
      this.yourTimezoneTarget.value = detectedTz;
    }

    // Show the detected timezone name in the "Your timezone" label
    this.yourTimezoneTarget.textContent = `Your timezone (${detectedTz})`;

    // If there's no start time, assume we want the NOT AVAILABLE block to start now and last a day.
    if (this.startTarget.value === "") {
      var d = this.getCurrentTimeLocally();
      this.startTarget.value = this.toISODateString(d);
      this.startTarget.dispatchEvent(new Event("change"));

      d.setDate(d.getDate() + 1);
      this.finishTarget.value = this.toISODateString(d);
      this.finishTarget.dispatchEvent(new Event("change"));
    }

    this.toggleAllDay();
  }

  toggleAllDay() {
    const allDay = this.allDayTarget.checked;

    if (this.hasTimeFieldsTarget) {
      this.timeFieldsTarget.classList.toggle("hidden", allDay);
    }

    if (allDay) {
      const startDate = this.startTarget.value.split("T")[0];
      const finishDate = this.finishTarget.value.split("T")[0];
      this.startTarget.type = "date";
      this.startTarget.value = startDate;
      this.finishTarget.type = "date";
      this.finishTarget.value = finishDate;
    } else {
      const startVal = this.startTarget.value;
      const finishVal = this.finishTarget.value;
      this.startTarget.type = "datetime-local";
      this.startTarget.value = startVal.includes("T") ? startVal : startVal + "T09:00";
      this.finishTarget.type = "datetime-local";
      this.finishTarget.value = finishVal.includes("T") ? finishVal : finishVal + "T17:00";
    }
  }

  getCurrentTimeLocally() {
    var d = new Date();
    d.setTime(d.getTime() - (d.getTimezoneOffset() * 60 * 1000));
    return d;
  }

  toISODateOnly(d) {
    function pad(n){return n<10 ? '0'+n : n}
    return d.getUTCFullYear()+'-'
    + pad(d.getUTCMonth()+1)+'-'
    + pad(d.getUTCDate());
  }

  toISODateString(d){
    function pad(n){return n<10 ? '0'+n : n}
    return d.getUTCFullYear()+'-'
    + pad(d.getUTCMonth()+1)+'-'
    + pad(d.getUTCDate())+'T'
    + pad(d.getUTCHours())+':'
    + pad(d.getUTCMinutes());
  }
}
